import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticQuery, graphql } from "gatsby"
import { Remarkable } from 'remarkable';
var md = new Remarkable();


const Faqs = () => (
    <StaticQuery query={Faqsquery} render={data=>{
      
        return (  
                <>
        <Layout>
            <SEO title="FAQs" />            
                   

        <section class="section-2 offers" style={{background:"#eef4ed"}}>
            <div class="container">
                <div class="row text-center intro">

                {data.allMarkdownRemark.edges.map((tag,index) => ( 
                  
                  <>
                    <div class="col-12" style={{textAlign: "left"}}>
                         <h2 style={{fontSize:'20px'}}>{tag.node.frontmatter.title}</h2>
                        <div class="row item widget-tags">
                            <div class="col-12 align-self-center">
                           <div class="col-12" dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.description)}}>
                          
                            </div>
                            <br></br>

                            </div>
                        </div>
                    </div>
                    
                     </>
                    
                      ))}
                     
                   </div>
        
                <div class="row justify-content-center items">
            </div>
         </div>
    </section>
    </Layout>
                  
            </>
 )
}}/>
)

export const Faqsquery = graphql`
query FaqsIndex {
  allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/faqs/"}}, sort: {fields: frontmatter___postnumber, order: ASC}) {
    edges {
      node {
        id
        frontmatter {
          title
          description
          postnumber
        }
      }
    }
  }
}


 `

export default Faqs